/* eslint-disable no-unused-vars */
import FbAccountService from "@/services/data/fb-account";

import { SET_DATA, SET_PAGINATION } from "./types";

export async function fetchData({commit}, params) {
  const {data} = await FbAccountService.get(params);
  const {accounts, pagination} = data.data;
  commit(SET_DATA, accounts);
  commit(SET_PAGINATION, pagination);
  return accounts;
}

export async function importData({commit}, params) {
  const {data} = await FbAccountService.import(params);
  return data;
}

export async function exportData({commit}, params) {
  const {data} = await FbAccountService.export(params);
  return data;
}

export async function deleteData({commit}, params) {
  const {data} = await FbAccountService.delete(params);
  return data;
}

export async function fetchById({commit}, id) {
  const {data} = await FbAccountService.getById(id);
  return data.data;
}

export async function unassignTag({commit}, params) {
  const {data} = await FbAccountService.unassignTag(params);
  return data;
}

export async function unassignTagByFilter({commit}, params) {
  const {data} = await FbAccountService.unassignTagByFilter(params);
  return data;
}

export async function countDeletedData({commit}) {
  const {data} = await FbAccountService.countDeletedData();
  return data;
}

export async function removeTrash({commit}) {
  const {data} = await FbAccountService.removeTrash();
  return data;
}

export async function restoreTrash({commit}) {
  const {data} = await FbAccountService.restoreTrash();
  return data;
}
